import { useQueryStates, parseAsInteger } from 'nuqs'

export const useIndeedFlexJobShiftsFiltersQueryState = () => {
  return useQueryStates(
    {
      ifJobId: parseAsInteger,
    },
    {
      urlKeys: {
        ifJobId: 'if-job-id',
      },
    }
  )
}
